(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gallery-lightbox')) {
    const SPRING = 'cubic-bezier(0.22, 1, 0.36, 1)';

    /**
     * Opens gallery photos in a native <dialog>. The photo grows out of its thumbnail and shrinks back
     * into it on close. Every animation starts from where the photo is on screen right now, so a close
     * can be reversed (tap the photo) or an open cut short (close) without a jump.
     */
    class GalleryLightbox extends HTMLElement {
      #animation = null;
      #opener = null;
      #restBox = null;
      #token = 0;
      #closing = false;

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.fullImage = this.querySelector('[data-lightbox-image]');
        this.addEventListener('click', this.#handleClick);
        this.dialog.addEventListener('cancel', this.#handleCancel);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.#handleResize);
      }

      /** @param {MouseEvent} event */
      #handleClick = (event) => {
        if (this.#closing && event.target === this.fullImage) {
          this.#reopen();
          return;
        }

        const opener = event.target.closest('[data-full]');
        if (opener) {
          this.#open(opener);
          return;
        }

        const closer = event.target.closest('[data-lightbox-close]');
        if (closer || event.target === this.dialog) this.#close();
      };

      /** Escape closes with the animation instead of cutting it off. @param {Event} event */
      #handleCancel = (event) => {
        event.preventDefault();
        this.#close();
      };

      #handleResize = () => {
        if (!this.#opener) return;
        this.#animation?.cancel();
        this.#fit();
        this.#restBox = this.fullImage.getBoundingClientRect();
      };

      /** Sizes the photo to fit the viewport, keeping its proportions. */
      #fit() {
        const thumb = this.#opener.querySelector('img');
        const ratio = thumb.naturalWidth / thumb.naturalHeight;
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const maxWidth = Math.min(window.innerWidth * 0.94, 80 * rem);
        const maxHeight = window.innerHeight * 0.85;
        const width = Math.min(maxWidth, maxHeight * ratio);
        this.fullImage.style.width = `${width}px`;
        this.fullImage.style.height = `${width / ratio}px`;
      }

      /** @param {HTMLElement} opener */
      #open(opener) {
        const thumb = opener.querySelector('img');
        const token = ++this.#token;
        this.#opener = opener;
        this.#closing = false;

        // The thumbnail stands in until the large file has decoded.
        this.fullImage.alt = opener.dataset.alt ?? '';
        this.fullImage.src = thumb.currentSrc || thumb.src;
        if (thumb.naturalWidth) this.#fit();
        this.dialog.showModal();
        window.addEventListener('resize', this.#handleResize);

        // Reading layout also lets the backdrop start from zero before it fades in.
        this.#restBox = this.fullImage.getBoundingClientRect();
        this.#animateTo(
          { transform: 'none', opacity: '1' },
          450,
          { transform: this.#thumbnailTransform(), opacity: '0' },
        );
        this.dialog.dataset.state = 'open';

        this.#upgrade(opener.dataset.full, token);
      }

      /** Swaps in the large file once it is ready, at the same size, so nothing jumps. */
      async #upgrade(url, token) {
        const large = new Image();
        large.src = url;
        try {
          await large.decode();
        } catch {
          return; // keep the thumbnail
        }
        if (token === this.#token && this.dialog.open) this.fullImage.src = url;
      }

      /** Where the photo must be, relative to its resting box, to sit exactly over its thumbnail. */
      #thumbnailTransform() {
        const from = this.#opener.getBoundingClientRect();
        const to = this.#restBox;
        return `translate(${from.left - to.left}px, ${from.top - to.top}px) scale(${from.width / to.width}, ${from.height / to.height})`;
      }

      /** The photo's look on screen right now, mid-animation or not. */
      #current() {
        const style = getComputedStyle(this.fullImage);
        return { transform: style.transform, opacity: style.opacity };
      }

      /**
       * Animates from `start` (default: where the photo is right now) to `target`. Starting from the
       * live value is what makes an interruption seamless. Reduced motion gets a short fade instead.
       */
      #animateTo(target, duration, start = this.#current()) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const keyframes = reduced
          ? [{ opacity: start.opacity }, { opacity: target.opacity }]
          : [
              { transformOrigin: '0 0', transform: start.transform },
              { transformOrigin: '0 0', transform: target.transform },
            ];

        const animation = this.fullImage.animate(keyframes, {
          duration: reduced ? 150 : duration,
          easing: reduced ? 'linear' : SPRING,
          fill: 'both',
        });
        this.#animation?.cancel(); // the new animation is already in place, so nothing flashes
        this.#animation = animation;
        return animation;
      }

      async #close() {
        if (!this.dialog.open || this.#closing) return;
        this.#closing = true;
        delete this.dialog.dataset.state;
        window.removeEventListener('resize', this.#handleResize);

        // Back into the thumbnail it came from: same path as the way in, and it starts moving at once.
        const animation = this.#animateTo({ transform: this.#thumbnailTransform(), opacity: '0' }, 350);
        try {
          await animation.finished;
        } catch {
          return; // a newer animation took over: the photo was reopened
        }
        this.dialog.close();
        animation.cancel();
        this.#closing = false;
      }

      /** Reverses a close that is still playing. */
      #reopen() {
        this.#closing = false;
        window.addEventListener('resize', this.#handleResize);
        this.dialog.dataset.state = 'open';
        this.#animateTo({ transform: 'none', opacity: '1' }, 450);
      }
    }

    customElements.define('gallery-lightbox', GalleryLightbox);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('header-menu')) {
    /** Animates the phone menu open and closed. The panel can be reversed at any moment mid-motion. */
    class HeaderMenu extends HTMLElement {
      #closeTimer = 0;

      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.panel = this.querySelector('.header__drawer-panel');
        this.summary.addEventListener('click', this.#handleToggle);
        this.addEventListener('keydown', this.#handleKeydown);
        this.addEventListener('click', this.#handleLinkClick);
        document.addEventListener('click', this.#handleOutsideClick);
      }

      disconnectedCallback() {
        clearTimeout(this.#closeTimer);
        document.removeEventListener('click', this.#handleOutsideClick);
      }

      get isOpen() {
        return this.dataset.state === 'open';
      }

      /** @param {MouseEvent} event */
      #handleToggle = (event) => {
        event.preventDefault();
        if (this.isOpen) this.close();
        else this.open();
      };

      /** @param {KeyboardEvent} event */
      #handleKeydown = (event) => {
        if (event.key !== 'Escape' || !this.isOpen) return;
        this.close();
        this.summary.focus();
      };

      /** @param {MouseEvent} event */
      #handleLinkClick = (event) => {
        if (event.target.closest('.header__drawer-panel a')) this.close();
      };

      /** @param {MouseEvent} event */
      #handleOutsideClick = (event) => {
        if (this.isOpen && !this.contains(event.target)) this.close();
      };

      open() {
        clearTimeout(this.#closeTimer);
        this.details.open = true;
        // Read layout so the panel transitions from where it is now: hidden, or part-way through a close.
        this.panel.getBoundingClientRect();
        this.dataset.state = 'open';
      }

      close() {
        clearTimeout(this.#closeTimer);
        delete this.dataset.state;
        // Keep the <details> open until the panel has shrunk back into the button.
        const seconds = parseFloat(getComputedStyle(this.panel).transitionDuration) || 0;
        this.#closeTimer = setTimeout(() => {
          this.details.open = false;
        }, seconds * 1000);
      }
    }

    customElements.define('header-menu', HeaderMenu);
  }

  // Lets iOS Safari show :active feedback the moment a finger lands.
  document.addEventListener('touchstart', () => {}, { passive: true });

  {
    // Marks the header once the page has scrolled, which fades in the scroll edge.
    const markScrolled = () => {
      document.querySelector('.header')?.toggleAttribute('data-stuck', window.scrollY > 8);
    };
    markScrolled();
    window.addEventListener('scroll', markScrolled, { passive: true });
  }

  } catch(e) { console.error(e); }
})();
})();
